
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexAy5g7tNrd_45gorJhb9snWUzBBzWaBn3JJCXY5LVejPewMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/index.vue?macro=true";
import { default as indexKf4wLH9fykGf15thagUv6SksIhdCPxCl0PmGAhOoQ48Meta } from "/codebuild/output/src2791215878/src/zazos-web/pages/login/index.vue?macro=true";
import { default as set_45workspacex7_45qo96r_Gd3K3zQiv1NthI2Pd23BwYf6X4DItibxu4Meta } from "/codebuild/output/src2791215878/src/zazos-web/pages/set-workspace.vue?macro=true";
import { default as index0wiZfQ5crwx6iI9MtN2H3c6lST4UUaOabjDiiUomVJkMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/sign-up/index.vue?macro=true";
import { default as indexYbjTLXZWmU1aph_45OYQ6keLvR0csl_RpF2Gu56DYtZqEMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/magic-link/index.vue?macro=true";
import { default as indexP6i8bdP0EGA3akB33goBh5hrBLo313z_PMFmEqszAuwMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/m/index.vue?macro=true";
import { default as index_45gO49iI6oo_IkJzMuVAYp8flWZ_kQj3sFP8Jhujlm00Meta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/index.vue?macro=true";
import { default as newkfBTA6ynRl35Tt92FALFJuJ9CHLErKFzgoUXGn3y49EMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/new.vue?macro=true";
import { default as account_45configurationT61a8gkTTKOVOWxI3F2EKJxDdmY5aVPuK6AHzwJJQt4Meta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/m/account-configuration.vue?macro=true";
import { default as index1wyz9avwJzWGv443p8sFNoBX31Ok8R3k_GWsUIKdENsMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/[recordId]/index.vue?macro=true";
import { default as m9WZqLVQhkl8JPg_454y0SMu_bI3EKiAGqy2zUt6TI3hUsMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/m.vue?macro=true";
import { default as indexNkfVJxMCyUvjBeXDr2eLaS6NJJ4f1mnEvyOe7cC4DvMMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/reset-password/index.vue?macro=true";
import { default as index75_45e6DgzjpRDqm3d1AzidOBtk6W9MuPIKVkOJGLqr18Meta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/index.vue?macro=true";
import { default as indexk61g60Rp_45oSY0QbQdQpug_45aS1fSoMQXa9x_452E5l5aMQMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/index.vue?macro=true";
import { default as indexBa5ryWBR8OCTzSyguoKOP85iiV7_45ESQibfT_jIQeuloMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/index.vue?macro=true";
import { default as user_45signup3WO851DYZCbAanlzau8bbWQGfAVzlmqCzEt7XtsAbbkMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-signup.vue?macro=true";
import { default as indexeDc5fu4phUz1dFC0OIPycqS8grINJYxob2R696OxXLgMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/users/index.vue?macro=true";
import { default as indexSXTN31ekUfCc7ZpkJjakNS9fY2YDXbwBNG5EOZyWoe8Meta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/tokens/index.vue?macro=true";
import { default as index9xUNWqdGXTQP1bUVbWH7QcupJpNYib3_45WplXOb4vfqcMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/internal/index.vue?macro=true";
import { default as newLApCtg8M3h8tIFMAsyFT7l8oFZ9Nb_Wl4_45yOlNBy1CoMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/new.vue?macro=true";
import { default as _91id_9391_zQouy6QCvw3jM6FN9azWpb48bgsUkWnGmXNJ5faYMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/[id].vue?macro=true";
import { default as index2uz8cbzYWStAEhWbi3uKZU55xtOclxh6sv_45s5rQJYEwMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/app-builder/index.vue?macro=true";
import { default as indexu_tJni1eStvlc_biYqX6VgOuOAg9tmCCFv6lAvKTDrgMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/export-data/index.vue?macro=true";
import { default as indexquXKsFwsAveqg966TsXJO4GPlp4ahMydobUyJanSzo0Meta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/index.vue?macro=true";
import { default as indexhlac3FgiT7coZxscyral4WIqtHrNMex3xIe6cDHtm7YMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/index.vue?macro=true";
import { default as index5gM5kj_7nnni1g_PBWUkGsy0JNiyZ4QS47oBQ7DuCyEMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/authentication/index.vue?macro=true";
import { default as indexTABrS04WuXkBgOlbHSdXivIgX39EoyUKHEytbEcDZ78Meta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/email-analytics/index.vue?macro=true";
import { default as indexLau_45JpZQU0TFTPQNPvxDmiFpje7RoVN6hNPWFTSf7yUMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/system-entities/index.vue?macro=true";
import { default as _91providerSlug_93rHVxSP9enREs5r9nLAatNry_45_45uKkP35giS4mLeGpdYUMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/[providerSlug].vue?macro=true";
import { default as indexFBZ_45Vo8revnr9UnTO6WanVc4fdUTWS5mnJxauPlvLEcMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/global-parameters-manager/index.vue?macro=true";
import { default as settingsNTzqdqr0hM5DqpTpC2Q7zA1QJDbZZxBtvL8EwnfE_45lkMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings.vue?macro=true";
import { default as indexP6xLRixA_m6_nw_thAtEEc_45BVO7yIWavNSgr9rKSaC4Meta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/data/index.vue?macro=true";
import { default as _91id_93NhtT_45gOoycBboRnUhdcBr45ItDFUI03ORiuwAcPyxlMMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/pages/[id].vue?macro=true";
import { default as indexd_aWlFCINhvN2Y0_OqnSqRSp1DIdh3oFPTNyrtK4IBEMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/pages/index.vue?macro=true";
import { default as indexj1Y8_loDpUSb2bNas7_fgawEWkDctqesskuqows_viEMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/index.vue?macro=true";
import { default as importBkjsTqdbS1JFaSibJCedLZggYdDuLZH169__uNLhT8QMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/import.vue?macro=true";
import { default as schemaL6aH6co_3m_6z2G_lA76UQ401iqcPohTMmLhRiYcHdcMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/schema.vue?macro=true";
import { default as index5MdPCbbgO7Je4u51Ty3J1jzpyVdregwiggbBB7Vq_45RgMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/automations/index.vue?macro=true";
import { default as indexWQ7NywU5gMkkjWwwcAsxJuTPrDIGixY6ykL4Hgk3NVIMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/index.vue?macro=true";
import { default as historyDLGeOc3GHqwRWP6_ssmwQ0Nj7_VFFfnBdr5oEfaRToYMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/history.vue?macro=true";
import { default as studioX2W_7Z8aZ2td7kn2YYF9lWtGBmUNLTVywEwM9g5h24QMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio.vue?macro=true";
import { default as index76aCn_J_45ftvv3j2ovMwCxm2AN8JhnKTHovTtNL62NpMMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/p/index.vue?macro=true";
import { default as index8DCSgCDYDXyJbYbgq_YL8A4CZ4J8uEs9HbZ17HcCSfcMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/mfa/index.vue?macro=true";
import { default as index_nrrlAfpUR4IcbJvk_0_45pjP9TY3wBw4Sd9mZstOLy4oMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/login/index.vue?macro=true";
import { default as index5KDA5Uditr4jy2AH4UdoxtGs8zBTTJLvGt6Btb6jf5cMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/store/index.vue?macro=true";
import { default as _91app_93nxSzsdbRnbhv65_9sQD1R5NfAO0mpo8YaSj8nmlXK6MMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/install/[app].vue?macro=true";
import { default as index4P9FTdwRNgPWzgQgSP2JKd0NooleKceMgUiWYZb3bS0Meta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/loading/index.vue?macro=true";
import { default as indexK7yW5jf5K6cWRto6h6dyFhKOqqHxDsoUv7ekU2Ed0VAMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/sign-up/index.vue?macro=true";
import { default as reset_45passwordIJZGEXQK9tdFHgchRL56cGS9I2ZPIUEoVDh7TdLizMsMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/reset-password.vue?macro=true";
import { default as index3U1y8HLxa6dfr0sL54GmOApyn8UphwkxlVx_8QTAFMYMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/sso/saml/index.vue?macro=true";
import { default as indexUyc2_f2mH9YWeCBPdC2fMOKHbF2odYMN8MKqfHQjy_oMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/mfa/setup/index.vue?macro=true";
import { default as indexl2zCZXuoiiiIDuOFjAINjJhwoIY6VVKLD4hYL3wcvk0Meta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/index.vue?macro=true";
import { default as _91appName_93piB9N8e0_45OHD26qTuGv_zQrWL6WTm_q5N8bzh_IavRAMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/store/apps/[appName].vue?macro=true";
import { default as indexB0rbTcVsMik070wgIZk_45Qs0fL5qowIoflKbpsNtCbzYMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/install/-review/index.vue?macro=true";
import { default as indexFIuAaDZMKtHXhQufTBOIUSMqwu0NG4UByjF_wfAb6j8Meta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/email-validation/index.vue?macro=true";
import { default as indexPFMSeD_2l3eh1DBzF8f3LNg18q_U0bIp_45pYVrXmkv8sMeta } from "/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/r/[recordId]/index.vue?macro=true";
export default [
  {
    name: "index___en",
    path: "/en",
    meta: indexAy5g7tNrd_45gorJhb9snWUzBBzWaBn3JJCXY5LVejPewMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/",
    meta: indexAy5g7tNrd_45gorJhb9snWUzBBzWaBn3JJCXY5LVejPewMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/index.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/login/index.vue")
  },
  {
    name: "login___pt",
    path: "/login",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/login/index.vue")
  },
  {
    name: "set-workspace___en",
    path: "/en/set-workspace",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/set-workspace.vue")
  },
  {
    name: "set-workspace___pt",
    path: "/set-workspace",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/set-workspace.vue")
  },
  {
    name: "sign-up___en",
    path: "/en/sign-up",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/sign-up/index.vue")
  },
  {
    name: "sign-up___pt",
    path: "/sign-up",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/sign-up/index.vue")
  },
  {
    name: "magic-link___en",
    path: "/en/magic-link",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/magic-link/index.vue")
  },
  {
    name: "magic-link___pt",
    path: "/magic-link",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/magic-link/index.vue")
  },
  {
    name: m9WZqLVQhkl8JPg_454y0SMu_bI3EKiAGqy2zUt6TI3hUsMeta?.name,
    path: "/en/t/:tenantSlug()/m",
    meta: m9WZqLVQhkl8JPg_454y0SMu_bI3EKiAGqy2zUt6TI3hUsMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/m.vue"),
    children: [
  {
    name: "t-tenantSlug-m___en",
    path: "",
    meta: indexP6i8bdP0EGA3akB33goBh5hrBLo313z_PMFmEqszAuwMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/m/index.vue")
  },
  {
    name: "t-tenantSlug-m-viewId___en",
    path: ":viewId()",
    meta: index_45gO49iI6oo_IkJzMuVAYp8flWZ_kQj3sFP8Jhujlm00Meta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/index.vue")
  },
  {
    name: "t-tenantSlug-m-viewId-r-new___en",
    path: ":viewId()/r/new",
    meta: newkfBTA6ynRl35Tt92FALFJuJ9CHLErKFzgoUXGn3y49EMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/new.vue")
  },
  {
    name: "t-tenantSlug-m-account-configuration___en",
    path: "account-configuration",
    meta: account_45configurationT61a8gkTTKOVOWxI3F2EKJxDdmY5aVPuK6AHzwJJQt4Meta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/m/account-configuration.vue")
  },
  {
    name: "t-tenantSlug-m-viewId-r-recordId___en",
    path: ":viewId()/r/:recordId()",
    meta: index1wyz9avwJzWGv443p8sFNoBX31Ok8R3k_GWsUIKdENsMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/[recordId]/index.vue")
  }
]
  },
  {
    name: m9WZqLVQhkl8JPg_454y0SMu_bI3EKiAGqy2zUt6TI3hUsMeta?.name,
    path: "/t/:tenantSlug()/m",
    meta: m9WZqLVQhkl8JPg_454y0SMu_bI3EKiAGqy2zUt6TI3hUsMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/m.vue"),
    children: [
  {
    name: "t-tenantSlug-m___pt",
    path: "",
    meta: indexP6i8bdP0EGA3akB33goBh5hrBLo313z_PMFmEqszAuwMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/m/index.vue")
  },
  {
    name: "t-tenantSlug-m-viewId___pt",
    path: ":viewId()",
    meta: index_45gO49iI6oo_IkJzMuVAYp8flWZ_kQj3sFP8Jhujlm00Meta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/index.vue")
  },
  {
    name: "t-tenantSlug-m-viewId-r-new___pt",
    path: ":viewId()/r/new",
    meta: newkfBTA6ynRl35Tt92FALFJuJ9CHLErKFzgoUXGn3y49EMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/new.vue")
  },
  {
    name: "t-tenantSlug-m-account-configuration___pt",
    path: "account-configuration",
    meta: account_45configurationT61a8gkTTKOVOWxI3F2EKJxDdmY5aVPuK6AHzwJJQt4Meta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/m/account-configuration.vue")
  },
  {
    name: "t-tenantSlug-m-viewId-r-recordId___pt",
    path: ":viewId()/r/:recordId()",
    meta: index1wyz9avwJzWGv443p8sFNoBX31Ok8R3k_GWsUIKdENsMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/[recordId]/index.vue")
  }
]
  },
  {
    name: "reset-password___en",
    path: "/en/reset-password",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/reset-password/index.vue")
  },
  {
    name: "reset-password___pt",
    path: "/reset-password",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/reset-password/index.vue")
  },
  {
    name: "t-tenantSlug___en",
    path: "/en/t/:tenantSlug()",
    meta: index75_45e6DgzjpRDqm3d1AzidOBtk6W9MuPIKVkOJGLqr18Meta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/index.vue")
  },
  {
    name: "t-tenantSlug___pt",
    path: "/t/:tenantSlug()",
    meta: index75_45e6DgzjpRDqm3d1AzidOBtk6W9MuPIKVkOJGLqr18Meta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/index.vue")
  },
  {
    name: studioX2W_7Z8aZ2td7kn2YYF9lWtGBmUNLTVywEwM9g5h24QMeta?.name,
    path: "/en/t/:tenantSlug()/studio",
    meta: studioX2W_7Z8aZ2td7kn2YYF9lWtGBmUNLTVywEwM9g5h24QMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio.vue"),
    children: [
  {
    name: "t-tenantSlug-studio___en",
    path: "",
    meta: indexk61g60Rp_45oSY0QbQdQpug_45aS1fSoMQXa9x_452E5l5aMQMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/index.vue")
  },
  {
    name: settingsNTzqdqr0hM5DqpTpC2Q7zA1QJDbZZxBtvL8EwnfE_45lkMeta?.name,
    path: "settings",
    meta: settingsNTzqdqr0hM5DqpTpC2Q7zA1QJDbZZxBtvL8EwnfE_45lkMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings.vue"),
    children: [
  {
    name: "t-tenantSlug-studio-settings___en",
    path: "",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-signup___en",
    path: "user-signup",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-signup.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-users___en",
    path: "users",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/users/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-tokens___en",
    path: "tokens",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/tokens/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-internal___en",
    path: "internal",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/internal/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups-new___en",
    path: "user-groups/new",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/new.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups-id___en",
    path: "user-groups/:id()",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/[id].vue")
  },
  {
    name: "t-tenantSlug-studio-settings-app-builder___en",
    path: "app-builder",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/app-builder/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-export-data___en",
    path: "export-data",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/export-data/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups___en",
    path: "user-groups",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-integrations___en",
    path: "integrations",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-authentication___en",
    path: "authentication",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/authentication/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-email-analytics___en",
    path: "email-analytics",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/email-analytics/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-system-entities___en",
    path: "system-entities",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/system-entities/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-integrations-providerSlug___en",
    path: "integrations/:providerSlug()",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/[providerSlug].vue")
  },
  {
    name: "t-tenantSlug-studio-settings-global-parameters-manager___en",
    path: "global-parameters-manager",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/global-parameters-manager/index.vue")
  }
]
  },
  {
    name: "t-tenantSlug-studio-data___en",
    path: "data",
    meta: indexP6xLRixA_m6_nw_thAtEEc_45BVO7yIWavNSgr9rKSaC4Meta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/data/index.vue")
  },
  {
    name: "t-tenantSlug-studio-pages-id___en",
    path: "pages/:id()",
    meta: _91id_93NhtT_45gOoycBboRnUhdcBr45ItDFUI03ORiuwAcPyxlMMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/pages/[id].vue")
  },
  {
    name: "t-tenantSlug-studio-pages___en",
    path: "pages",
    meta: indexd_aWlFCINhvN2Y0_OqnSqRSp1DIdh3oFPTNyrtK4IBEMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/pages/index.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id___en",
    path: "data/:id()",
    meta: indexj1Y8_loDpUSb2bNas7_fgawEWkDctqesskuqows_viEMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/index.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id-import___en",
    path: "data/:id()/import",
    meta: importBkjsTqdbS1JFaSibJCedLZggYdDuLZH169__uNLhT8QMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/import.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id-schema___en",
    path: "data/:id()/schema",
    meta: schemaL6aH6co_3m_6z2G_lA76UQ401iqcPohTMmLhRiYcHdcMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/schema.vue")
  },
  {
    name: "t-tenantSlug-studio-automations___en",
    path: "automations",
    meta: index5MdPCbbgO7Je4u51Ty3J1jzpyVdregwiggbBB7Vq_45RgMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/automations/index.vue")
  },
  {
    name: "t-tenantSlug-studio-automations-id___en",
    path: "automations/:id()",
    meta: indexWQ7NywU5gMkkjWwwcAsxJuTPrDIGixY6ykL4Hgk3NVIMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/index.vue")
  },
  {
    name: "t-tenantSlug-studio-automations-id-history___en",
    path: "automations/:id()/history",
    meta: historyDLGeOc3GHqwRWP6_ssmwQ0Nj7_VFFfnBdr5oEfaRToYMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/history.vue")
  }
]
  },
  {
    name: studioX2W_7Z8aZ2td7kn2YYF9lWtGBmUNLTVywEwM9g5h24QMeta?.name,
    path: "/t/:tenantSlug()/studio",
    meta: studioX2W_7Z8aZ2td7kn2YYF9lWtGBmUNLTVywEwM9g5h24QMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio.vue"),
    children: [
  {
    name: "t-tenantSlug-studio___pt",
    path: "",
    meta: indexk61g60Rp_45oSY0QbQdQpug_45aS1fSoMQXa9x_452E5l5aMQMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/index.vue")
  },
  {
    name: settingsNTzqdqr0hM5DqpTpC2Q7zA1QJDbZZxBtvL8EwnfE_45lkMeta?.name,
    path: "settings",
    meta: settingsNTzqdqr0hM5DqpTpC2Q7zA1QJDbZZxBtvL8EwnfE_45lkMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings.vue"),
    children: [
  {
    name: "t-tenantSlug-studio-settings___pt",
    path: "",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-signup___pt",
    path: "user-signup",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-signup.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-users___pt",
    path: "users",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/users/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-tokens___pt",
    path: "tokens",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/tokens/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-internal___pt",
    path: "internal",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/internal/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups-new___pt",
    path: "user-groups/new",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/new.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups-id___pt",
    path: "user-groups/:id()",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/[id].vue")
  },
  {
    name: "t-tenantSlug-studio-settings-app-builder___pt",
    path: "app-builder",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/app-builder/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-export-data___pt",
    path: "export-data",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/export-data/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups___pt",
    path: "user-groups",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-integrations___pt",
    path: "integrations",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-authentication___pt",
    path: "authentication",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/authentication/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-email-analytics___pt",
    path: "email-analytics",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/email-analytics/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-system-entities___pt",
    path: "system-entities",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/system-entities/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-integrations-providerSlug___pt",
    path: "integrations/:providerSlug()",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/[providerSlug].vue")
  },
  {
    name: "t-tenantSlug-studio-settings-global-parameters-manager___pt",
    path: "global-parameters-manager",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/settings/global-parameters-manager/index.vue")
  }
]
  },
  {
    name: "t-tenantSlug-studio-data___pt",
    path: "data",
    meta: indexP6xLRixA_m6_nw_thAtEEc_45BVO7yIWavNSgr9rKSaC4Meta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/data/index.vue")
  },
  {
    name: "t-tenantSlug-studio-pages-id___pt",
    path: "pages/:id()",
    meta: _91id_93NhtT_45gOoycBboRnUhdcBr45ItDFUI03ORiuwAcPyxlMMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/pages/[id].vue")
  },
  {
    name: "t-tenantSlug-studio-pages___pt",
    path: "pages",
    meta: indexd_aWlFCINhvN2Y0_OqnSqRSp1DIdh3oFPTNyrtK4IBEMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/pages/index.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id___pt",
    path: "data/:id()",
    meta: indexj1Y8_loDpUSb2bNas7_fgawEWkDctqesskuqows_viEMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/index.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id-import___pt",
    path: "data/:id()/import",
    meta: importBkjsTqdbS1JFaSibJCedLZggYdDuLZH169__uNLhT8QMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/import.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id-schema___pt",
    path: "data/:id()/schema",
    meta: schemaL6aH6co_3m_6z2G_lA76UQ401iqcPohTMmLhRiYcHdcMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/schema.vue")
  },
  {
    name: "t-tenantSlug-studio-automations___pt",
    path: "automations",
    meta: index5MdPCbbgO7Je4u51Ty3J1jzpyVdregwiggbBB7Vq_45RgMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/automations/index.vue")
  },
  {
    name: "t-tenantSlug-studio-automations-id___pt",
    path: "automations/:id()",
    meta: indexWQ7NywU5gMkkjWwwcAsxJuTPrDIGixY6ykL4Hgk3NVIMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/index.vue")
  },
  {
    name: "t-tenantSlug-studio-automations-id-history___pt",
    path: "automations/:id()/history",
    meta: historyDLGeOc3GHqwRWP6_ssmwQ0Nj7_VFFfnBdr5oEfaRToYMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/history.vue")
  }
]
  },
  {
    name: "t-tenantSlug-p___en",
    path: "/en/t/:tenantSlug()/p",
    meta: index76aCn_J_45ftvv3j2ovMwCxm2AN8JhnKTHovTtNL62NpMMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/p/index.vue")
  },
  {
    name: "t-tenantSlug-p___pt",
    path: "/t/:tenantSlug()/p",
    meta: index76aCn_J_45ftvv3j2ovMwCxm2AN8JhnKTHovTtNL62NpMMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/p/index.vue")
  },
  {
    name: "t-tenantSlug-mfa___en",
    path: "/en/t/:tenantSlug()/mfa",
    meta: index8DCSgCDYDXyJbYbgq_YL8A4CZ4J8uEs9HbZ17HcCSfcMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/mfa/index.vue")
  },
  {
    name: "t-tenantSlug-mfa___pt",
    path: "/t/:tenantSlug()/mfa",
    meta: index8DCSgCDYDXyJbYbgq_YL8A4CZ4J8uEs9HbZ17HcCSfcMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/mfa/index.vue")
  },
  {
    name: "t-tenantSlug-login___en",
    path: "/en/t/:tenantSlug()/login",
    meta: index_nrrlAfpUR4IcbJvk_0_45pjP9TY3wBw4Sd9mZstOLy4oMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/login/index.vue")
  },
  {
    name: "t-tenantSlug-login___pt",
    path: "/t/:tenantSlug()/login",
    meta: index_nrrlAfpUR4IcbJvk_0_45pjP9TY3wBw4Sd9mZstOLy4oMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/login/index.vue")
  },
  {
    name: "t-tenantSlug-store___en",
    path: "/en/t/:tenantSlug()/store",
    meta: index5KDA5Uditr4jy2AH4UdoxtGs8zBTTJLvGt6Btb6jf5cMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/store/index.vue")
  },
  {
    name: "t-tenantSlug-store___pt",
    path: "/t/:tenantSlug()/store",
    meta: index5KDA5Uditr4jy2AH4UdoxtGs8zBTTJLvGt6Btb6jf5cMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/store/index.vue")
  },
  {
    name: "t-tenantSlug-install-app___en",
    path: "/en/t/:tenantSlug()/install/:app()",
    meta: _91app_93nxSzsdbRnbhv65_9sQD1R5NfAO0mpo8YaSj8nmlXK6MMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/install/[app].vue")
  },
  {
    name: "t-tenantSlug-install-app___pt",
    path: "/t/:tenantSlug()/install/:app()",
    meta: _91app_93nxSzsdbRnbhv65_9sQD1R5NfAO0mpo8YaSj8nmlXK6MMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/install/[app].vue")
  },
  {
    name: "t-tenantSlug-loading___en",
    path: "/en/t/:tenantSlug()/loading",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/loading/index.vue")
  },
  {
    name: "t-tenantSlug-loading___pt",
    path: "/t/:tenantSlug()/loading",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/loading/index.vue")
  },
  {
    name: "t-tenantSlug-sign-up___en",
    path: "/en/t/:tenantSlug()/sign-up",
    meta: indexK7yW5jf5K6cWRto6h6dyFhKOqqHxDsoUv7ekU2Ed0VAMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/sign-up/index.vue")
  },
  {
    name: "t-tenantSlug-sign-up___pt",
    path: "/t/:tenantSlug()/sign-up",
    meta: indexK7yW5jf5K6cWRto6h6dyFhKOqqHxDsoUv7ekU2Ed0VAMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/sign-up/index.vue")
  },
  {
    name: "t-tenantSlug-reset-password___en",
    path: "/en/t/:tenantSlug()/reset-password",
    meta: reset_45passwordIJZGEXQK9tdFHgchRL56cGS9I2ZPIUEoVDh7TdLizMsMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/reset-password.vue")
  },
  {
    name: "t-tenantSlug-reset-password___pt",
    path: "/t/:tenantSlug()/reset-password",
    meta: reset_45passwordIJZGEXQK9tdFHgchRL56cGS9I2ZPIUEoVDh7TdLizMsMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/reset-password.vue")
  },
  {
    name: "t-tenantSlug-sso-saml___en",
    path: "/en/t/:tenantSlug()/sso/saml",
    meta: index3U1y8HLxa6dfr0sL54GmOApyn8UphwkxlVx_8QTAFMYMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/sso/saml/index.vue")
  },
  {
    name: "t-tenantSlug-sso-saml___pt",
    path: "/t/:tenantSlug()/sso/saml",
    meta: index3U1y8HLxa6dfr0sL54GmOApyn8UphwkxlVx_8QTAFMYMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/sso/saml/index.vue")
  },
  {
    name: "t-tenantSlug-mfa-setup___en",
    path: "/en/t/:tenantSlug()/mfa/setup",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/mfa/setup/index.vue")
  },
  {
    name: "t-tenantSlug-mfa-setup___pt",
    path: "/t/:tenantSlug()/mfa/setup",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/mfa/setup/index.vue")
  },
  {
    name: "t-tenantSlug-p-viewId___en",
    path: "/en/t/:tenantSlug()/p/:viewId()",
    meta: indexl2zCZXuoiiiIDuOFjAINjJhwoIY6VVKLD4hYL3wcvk0Meta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/index.vue")
  },
  {
    name: "t-tenantSlug-p-viewId___pt",
    path: "/t/:tenantSlug()/p/:viewId()",
    meta: indexl2zCZXuoiiiIDuOFjAINjJhwoIY6VVKLD4hYL3wcvk0Meta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/index.vue")
  },
  {
    name: "t-tenantSlug-store-apps-appName___en",
    path: "/en/t/:tenantSlug()/store/apps/:appName()",
    meta: _91appName_93piB9N8e0_45OHD26qTuGv_zQrWL6WTm_q5N8bzh_IavRAMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/store/apps/[appName].vue")
  },
  {
    name: "t-tenantSlug-store-apps-appName___pt",
    path: "/t/:tenantSlug()/store/apps/:appName()",
    meta: _91appName_93piB9N8e0_45OHD26qTuGv_zQrWL6WTm_q5N8bzh_IavRAMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/store/apps/[appName].vue")
  },
  {
    name: "t-tenantSlug-install--review___en",
    path: "/en/t/:tenantSlug()/install/-review",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/install/-review/index.vue")
  },
  {
    name: "t-tenantSlug-install--review___pt",
    path: "/t/:tenantSlug()/install/-review",
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/install/-review/index.vue")
  },
  {
    name: "t-tenantSlug-email-validation___en",
    path: "/en/t/:tenantSlug()/email-validation",
    meta: indexFIuAaDZMKtHXhQufTBOIUSMqwu0NG4UByjF_wfAb6j8Meta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/email-validation/index.vue")
  },
  {
    name: "t-tenantSlug-email-validation___pt",
    path: "/t/:tenantSlug()/email-validation",
    meta: indexFIuAaDZMKtHXhQufTBOIUSMqwu0NG4UByjF_wfAb6j8Meta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/email-validation/index.vue")
  },
  {
    name: "t-tenantSlug-p-viewId-r-recordId___en",
    path: "/en/t/:tenantSlug()/p/:viewId()/r/:recordId()",
    meta: indexPFMSeD_2l3eh1DBzF8f3LNg18q_U0bIp_45pYVrXmkv8sMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/r/[recordId]/index.vue")
  },
  {
    name: "t-tenantSlug-p-viewId-r-recordId___pt",
    path: "/t/:tenantSlug()/p/:viewId()/r/:recordId()",
    meta: indexPFMSeD_2l3eh1DBzF8f3LNg18q_U0bIp_45pYVrXmkv8sMeta || {},
    component: () => import("/codebuild/output/src2791215878/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/r/[recordId]/index.vue")
  }
]